import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { UserStore } from '../stores/user.store';

export const isLoggedOutGuard: CanActivateFn = (route) => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  // OAuth return (JWT or error in query) — allow login to handle or show message.
  if (route.queryParamMap.get('token') || route.queryParamMap.get('error')) {
    return true;
  }

  if (!userStore.isAuthenticated()) {
    return true;
  }

  router.navigate(['/user']);
  return false;
};
